<template>
  <main class="mobile_create_notice_modal">
    <div class="modal_wrap bottom_modal" :class="{ on: show }">
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <!-- <div class="safe_modal_close" @click="$emit('close')">
            <img :src="require('@/assets/front/images/new/i_x_w.png')" alt="" />
          </div> -->
          <div class="mobile_create_con_pop">
            <div class="pop_content">
              <div class="info_img">
                <img
                  :src="
                    require('@/assets/front/images/v2/character/img_finger_01.png')
                  "
                  alt=""
                />
              </div>
              <div class="info_title">
                채팅을 시작하기전 꼭 읽어주세요!
              </div>
              <div class="info_con_wrap">
                <div class="info_con">
                  <!-- <div class="con_title">미스터리 쇼퍼란?</div> -->
                  <div class="con_txt mb12">
                    <div class="txt_1">1. 고객 후기 확인하기</div>
                    <div class="txt_2">
                      <span>다른 고객들의 후기</span>를 읽고 매장에 대한
                      <span>신뢰도를 확인</span>해 보세요.
                    </div>
                  </div>
                  <div class="con_txt mb12">
                    <div class="txt_1">2. 사전승낙마크 확인하기</div>
                    <div class="txt_2">
                      사전승낙마크는 이동통신사와 정한 기준을 통과한 매장에만
                      부여되는 표식이에요.<br /><span
                        >휴대폰은 무선, 인터넷은 유선 사전승낙을 꼭 확인</span
                      >하세요.
                    </div>
                  </div>
                  <div class="con_txt">
                    <div class="txt_1 rd">3. 개통 후 확인하기</div>
                    <div class="txt_2">
                      개통 후 수신 받는 개통내역 안내문자나 고객센터 앱을 통하여
                      아래의 항목이 견적내역과 일치하는지 반드시 확인하세요!<br />
                      <span class="rd">
                        개통한 기기 · 할부금과 기간 · 요금제 · 할인 유형
                        (공시지원금 or 선택약정)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btm_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="$emit('close')">
                뒤로가기
              </button>
              <button class="btn" @click="agree">
                확인
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'MobileNoticeModal',
  props: {
    show: Boolean,
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    agree() {
      this.$emit('agree');
    },
  },
};
</script>
